import { useEffect } from "react";
import { Box } from "@mui/material";
import { sxStyles } from "./HMT.styles";
import mapRawStringToReactElement from "lib/util/ReactComponentUtil/mapRawStringToReactElement/MapRawStringtoReactElement";
import { logEventToGoogleAnalytics } from "lib/util/GoogleAnalyticsUtil/logEvent";
import { EVENTS } from "lib/util/GoogleAnalyticsUtil/events";
import { useAppDispatch, useAppSelector } from "lib/redux/hooks";
import { CHAS_URL, NUHS_POSTALCODE } from "../../Dashboard/Constants";
import IconLink from "lib/components/links/IconLink/IconLink";
import {
  navigateToExternalInMobileBrowser,
  navigateToExternalInMobileBrowserForStandardPage,
} from "lib/routing/navigate/navigate";
import { selectMhm, selectMhmSystemSettings } from "ui/mhm/ducks/selectors";
import { selectNavigation } from "lib/redux/navigation/selectors";
import { screenForLifeBackUrl } from "lib/configs/configs/config";
import { enqueueMessage } from "lib/redux/navigation/navigationSlice";
import { MessageActions } from "lib/routing/messageChannel/messageActions";

const HMT = () => {
  const categoryCode = useAppSelector(selectMhm).selectedCategory.code;
  const categoryIntro = useAppSelector(selectMhmSystemSettings)
    .systemSettingMap[`CP${categoryCode}INTRO`].DisplayValue;
  const programName = useAppSelector(selectNavigation).navBarDisplayName;
  const classes = sxStyles({ categoryCode });
  const dispatch = useAppDispatch();

  useEffect(
    () =>
      logEventToGoogleAnalytics(
        EVENTS.VIEW_MHM_PROGRAM_TEMPLATE,
        programName?.toLocaleLowerCase().replace(" ", "_"),
        programName || "",
      ),
    [programName],
  );

  return (
    <Box sx={classes.contentBox}>
      <Box data-testid="cat-intro">
        {mapRawStringToReactElement(categoryIntro ?? "")}
      </Box>
      <Box sx={classes.linksBox}>
        {categoryCode === "PR_CAN" ? (
          <>
            <IconLink
              title={
                "Colorectal Screening - Find the nearest place to get your FIT kit."
              }
              onClick={() => {
                dispatch(
                  enqueueMessage(
                    MessageActions.dosClinic({
                      postalCode: NUHS_POSTALCODE,
                      serviceTypes: ["ADD_COCS"],
                    }),
                  ),
                );
              }}
            />
            <IconLink
              title={
                "(For females) Breast Screening - Find the nearest place to get your mammogram."
              }
              onClick={() => {
                dispatch(
                  enqueueMessage(
                    MessageActions.dosClinic({
                      postalCode: NUHS_POSTALCODE,
                      serviceTypes: ["ADD_BCS"],
                    }),
                  ),
                );
              }}
            />
            <IconLink
              title={
                "(For females) Cervical screening - Find the nearest clinic."
              }
              onClick={() => {
                dispatch(
                  enqueueMessage(
                    MessageActions.dosClinic({
                      postalCode: NUHS_POSTALCODE,
                      serviceTypes: ["ADD_CCS"],
                    }),
                  ),
                );
              }}
            />
          </>
        ) : categoryCode === "PR_CDM" ? (
          <>
            <IconLink
              title={"Apply for CHAS subsidy."}
              onClick={() => {
                navigateToExternalInMobileBrowser(CHAS_URL);
              }}
            />
            <IconLink
              title={"Find a screening clinic near you."}
              onClick={() => {
                dispatch(
                  enqueueMessage(
                    MessageActions.dosClinic({
                      postalCode: NUHS_POSTALCODE,
                      serviceTypes: ["PR_CDM"],
                    }),
                  ),
                );
              }}
            />
          </>
        ) : categoryCode === "PR_CHS" ? (
          <>
            <IconLink
              title={
                "Find out about Healthier SG Screening, and check if you are eligible."
              }
              onClick={() => {
                navigateToExternalInMobileBrowserForStandardPage(
                  screenForLifeBackUrl(),
                  "hh",
                );
              }}
            />
            <IconLink
              title={"Find a screening clinic near you."}
              onClick={() => {
                // PR_CHS does not have a DOS weblink, it defaults to PR_CDM
                dispatch(
                  enqueueMessage(
                    MessageActions.dosClinic({
                      postalCode: NUHS_POSTALCODE,
                      serviceTypes: ["PR_CDM"],
                    }),
                  ),
                );
              }}
            />
          </>
        ) : categoryCode === "PR_VAX" ? (
          <>
            <IconLink
              title={"Vaccination - Find the nearest clinic."}
              onClick={() => {
                dispatch(
                  enqueueMessage(
                    MessageActions.dosClinic({
                      postalCode: NUHS_POSTALCODE,
                      serviceTypes: ["PR_VAX"],
                    }),
                  ),
                );
              }}
            />
          </>
        ) : null}
      </Box>
    </Box>
  );
};

export default HMT;
